import { useCallback } from 'react';
import { useDialog } from '@workspace/design-system/src/components';
import PricingTierModal from '@src/pages/Studio/PlanTemplate/PricingTierModal';
import ContentDetailModal from '@src/pages/Studio/PlanTemplate/ContentDetailModal';
import type { ProjectTemplateInfoResponseModel } from '@uniquegood/realworld-admin-interface';
import { planTypesToPricingTiers } from './utils';
import type { PricingTier } from './utils';

export function useTemplateModals() {
  const { openDialog, closeDialog } = useDialog();

  // 요금제 설정 모달 열기
  const openPricingTierModal = useCallback(
    (
      template: ProjectTemplateInfoResponseModel,
      onSave: (tiers: PricingTier[]) => void
    ) => {
      openDialog(
        <PricingTierModal
          defaultTiers={planTypesToPricingTiers(template.planTypes)}
          onSave={(tiers) => {
            onSave(tiers);
            closeDialog();
          }}
          onClose={closeDialog}
        />
      );
    },
    [openDialog, closeDialog]
  );

  // 콘텐츠 상세 모달 열기
  const openContentDetailModal = useCallback(
    (template: ProjectTemplateInfoResponseModel) => {
      openDialog(
        <ContentDetailModal
          content={{
            id: template.id,
            imageUrl: template.imageUrl || '',
            name: template.name,
            description: template.description || '',
            interactiveTechnologies: template.interactiveTechnologies?.map((tech) => tech.toString()) || [],
          }}
          onClose={closeDialog}
        />
      );
    },
    [openDialog, closeDialog]
  );

  return {
    openPricingTierModal,
    openContentDetailModal,
  };
}

